import { articleSensitivityLayout } from 'utils/layoutUtils';
import {bannerAd, singleBottomMPUProps, topMPUProps} from "../Common/components/GptProperties";

const rosTopMpu = {
  component: 'GooglePublisherTag',
  desktopColumn: 'right',
  desktopOrder: 1,
  handheldOrder: false,
  props: topMPUProps
};

const ocHomeProps = {
  ocSlot: ['football', 'leaderboard']
};

const leaderboardAd = {
  view: 'football'
};

const mostRead = {
  component: "MostReadFootball",
  desktopColumn: "right",
  desktopOrder: 1,
  handheldOrder: 4
};

const footballTips = {
  component: 'FootballTips',
  desktopColumn: 'right',
  desktopOrder: 2,
  handheldOrder: false
};

const advertOfferRight = {
  component: 'AdvertWrapper',
  desktopColumn: 'right',
  desktopOrder: 2,
  handheldOrder: false,
  props: {
    ocSlot: ["football", "mpu"],
    additionalProperties: {
      view: 'football'
    }
  }
};

const withAdverts = (...components) => ({
  bannerAd,
  leaderboardAd,
  components: [rosTopMpu, ...components]
});

const withAdvertsAndMostRead = (...components) => ({
  bannerAd,
  leaderboardAd,
  components: [mostRead, rosTopMpu, ...components]
});

const withAdvertsArticle = (...components) => ({
  leaderboardAd,
  components: [mostRead, rosTopMpu, ...components]
});

const withoutAdvertsArticle = (...components) => ({
  components: [mostRead, ...components]
});

const footballHomePageLayout = withAdvertsAndMostRead({
  component: 'MoreNews',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
},
{
  component: 'GptAdvert',
  props: {
    ocDetails: ocHomeProps,
    performDetails: singleBottomMPUProps
  },
  desktopColumn: 'left',
  desktopOrder: 2,
  handheldOrder: 2
},
footballTips,
advertOfferRight);

const footballLiveCentreLayout = withAdverts({
  component: 'FootballLiveHomeHeader',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
},
{
  component: 'FootballLiveHomeVidiprinterContainer',
  desktopColumn: 'right',
  desktopOrder: 2,
  handheldOrder: 2
},
{
  component: 'FootballLiveHomeTabs',
  desktopColumn: 'left',
  desktopOrder: 2,
  handheldOrder: 3
},
advertOfferRight);

const footballVidiprinterLayout = withAdverts({
  component: 'FootballVidiprinterPageContainer',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

const footballLeaguesLayout = withAdverts({
  component: 'FootballLeaguesContainer',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});


const footballMatchLayout = withAdverts({
  component: 'FootballLiveMatchContainer',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
},
advertOfferRight);

const footballFixturesLayout = withAdverts({
  component: 'FootballFixturesResults',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
},
advertOfferRight);

const footballCompetitionLayout = withAdverts({
  component: 'FootballCompetitionFixturesResults',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
},
advertOfferRight);

const footballTeamLayout = withAdverts({
  component: 'FootballTeamFixturesResults',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
},
advertOfferRight);

const footballTipsCentreLayout = withAdvertsAndMostRead({
  component: 'MoreNews',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

const footballPaperTalkLayout = withAdvertsAndMostRead({
  component: 'MoreNews',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

const article = {
  component: 'Article',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
};
const footballArticleLayout = withAdvertsArticle(article, footballTips);
const footballArticleSensitiveLayout = withoutAdvertsArticle(article, footballTips);

export default {
  '/football': footballHomePageLayout,

  '/football/live': footballLiveCentreLayout,
  '/football/live/filter/ongoing': footballLiveCentreLayout,
  '/football/live/filter/up-next': footballLiveCentreLayout,
  '/football/live/filter/finished': footballLiveCentreLayout,

  '/football/live/vidiprinter': footballVidiprinterLayout,

  '/football/league-tables': footballLeaguesLayout,
  '/football/league-tables/:name/:competition': footballLeaguesLayout,

  '/football/live/:matchId': footballMatchLayout,
  '/football/live/:matchId/commentary': footballMatchLayout,
  '/football/live/:matchId/preview': footballMatchLayout,
  '/football/live/:matchId/stats': footballMatchLayout,
  '/football/live/:matchId/teams': footballMatchLayout,
  '/football/live/:matchId/teams/home': footballMatchLayout,
  '/football/live/:matchId/teams/away': footballMatchLayout,
  '/football/live/:matchId/form': footballMatchLayout,
  '/football/live/:matchId/head-to-head': footballMatchLayout,
  '/football/live/:matchId/table': footballMatchLayout,
  '/football/live/:matchId/report': footballMatchLayout,
  '/football/live/:matchId/reaction': footballMatchLayout,

  '/football/results': footballFixturesLayout,
  '/football/results/:date': footballFixturesLayout,
  '/football/fixtures/competitions/:compName/:compId': footballCompetitionLayout,
  '/football/fixtures/competitions/:compName/:compId/:month': footballCompetitionLayout,
  '/football/results/competitions/:compName/:compId': footballCompetitionLayout,
  '/football/results/competitions/:compName/:compId/:month': footballCompetitionLayout,
  '/football/fixtures/teams/:teamName/:teamId/:compName/:compId': footballTeamLayout,
  '/football/results/teams/:teamName/:teamId/:compName/:compId': footballTeamLayout,

  '/football/fixtures': footballFixturesLayout,
  '/football/fixtures/:date': footballFixturesLayout,

  '/football/tips-centre': footballTipsCentreLayout,

  '/football/paper-talk': footballPaperTalkLayout,

  '/football/news/:title/:articleId': layout => articleSensitivityLayout(layout, footballArticleLayout, footballArticleSensitiveLayout)
};



// WEBPACK FOOTER //
// ./modules/Football/layouts.js